"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (virtual) { return function (frame) {
    setTimeout(function () {
        virtual.send('heartbeat');
    }, virtual.options.heartbeat);
}; });



// WEBPACK FOOTER //
// ./src/actions/receive/actions/heartbeatResp.ts